<header [class.bg-transparent]="background === 'transparent'" [class.text-black]="textColor === 'black'"
    [class.text-white]="textColor === 'white'" [class.overlay]="overlay"
    [class.mobile-nav-active]="mobileNavView === 'close'" [class.float]="!overlay">
    <div class="left">
        <a href="https://listique.com" aria-label="Listique Logo" (click)="mobileNavView = 'menu'">
            <img loading="lazy" src="/assets/images/logo.svg" class="logo" alt="Listique Logo" />
        </a>
        <div class="mobile-nav-icons" *ngIf="links.length > 0">
            <mat-icon svgIcon="menu" class="mobile-nav-icons"
                [style.display]="mobileNavView === 'menu' ? 'block' : 'none'" [class.text-black]="textColor === 'black'"
                [class.text-white]="textColor === 'white'" (click)="mobileNavView = 'close'"></mat-icon>
            <mat-icon svgIcon="close" [style.display]="mobileNavView === 'close' ? 'block' : 'none'"
                [class.text-black]="textColor === 'black'" [class.text-white]="textColor === 'white'"
                (click)="mobileNavView = 'menu'"></mat-icon>
        </div>
    </div>
    <nav>
        <ul>
            <li *ngFor="let link of links">
                <a [routerLink]="link.url" (click)="mobileNavView = 'menu'">
                    {{ link.title }}
                    <mat-icon svgIcon="chevron-right"></mat-icon>
                </a>
            </li>
        </ul>
    </nav>
    <div class="right">
        <app-button *ngIf="rightButton" [config]="rightButton"></app-button>
        <app-search-bar [micro]="true" placeholder="Search Partners..." *ngIf="showPartnerSearch"></app-search-bar>
    </div>
</header>